document.addEventListener('DOMContentLoaded', () => {
  const MAX_BAGS = () => window.BeanyBundleTier?.MAX_BAGS || 6;
  const BEANY_RETURN_URL_KEY = 'beany-product-return-url';
  const prefetchedNavUrls = new Set();

  const prefetchNavigationUrl = (url) => {
    if (!url || prefetchedNavUrls.has(url)) return;
    prefetchedNavUrls.add(url);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    document.head.appendChild(link);
    if (typeof fetch === 'function') {
      fetch(url, { credentials: 'same-origin' }).catch(() => {});
    }
  };

  const pathsMatch = (a, b) => {
    try {
      return new URL(a, window.location.origin).pathname === new URL(b, window.location.origin).pathname;
    } catch (_error) {
      return false;
    }
  };

  const navigateBackToProduct = (fallbackUrl) => {
    let stored = null;
    try {
      stored = sessionStorage.getItem(BEANY_RETURN_URL_KEY);
    } catch (_error) {
      /* ignore */
    }

    const target = stored || fallbackUrl || null;
    const canUseHistory =
      window.history.length > 1 &&
      document.referrer &&
      target &&
      pathsMatch(document.referrer, target);

    if (canUseHistory) {
      window.history.back();
      return;
    }

    if (target) {
      window.location.assign(target);
      return;
    }

    if (window.history.length > 1) {
      window.history.back();
    }
  };

  const root = document.querySelector('[data-step-2-root]');
  if (!root) return;
  document.body.classList.add('step-2-page-active');

  const fallbackProductUrl = root.dataset.productReturnUrl || '';
  let storedReturnUrl = null;
  try {
    storedReturnUrl = sessionStorage.getItem(BEANY_RETURN_URL_KEY);
  } catch (_error) {
    /* ignore */
  }
  prefetchNavigationUrl(storedReturnUrl || fallbackProductUrl);

  const params = new URLSearchParams(window.location.search);
  const isOneTime = root.dataset.purchaseMode === 'one_time';

  // One-time purchase always starts fresh — ignore club bag selection / handoff.
  let bags = isOneTime ? '1' : (params.get('bags') || '2');

  if (isOneTime) {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('bags') !== '1') {
        url.searchParams.set('bags', '1');
        window.history.replaceState({}, '', `${url.pathname}${url.search}`);
      }
    } catch (_err) {
      /* ignore */
    }
  }

  const flavorKeyMap = {
    original: 'original',
    french_vanilla: 'vanilla',
    cookies_caramel: 'caramel',
  };

  let handoffSelections = null;
  try {
    if (isOneTime) {
      sessionStorage.removeItem('beany-home-bundle-handoff');
      sessionStorage.setItem('beany-purchase-mode', 'one_time');
      window.__beanyPurchaseMode = 'one_time';
    } else {
      const handoffRaw = sessionStorage.getItem('beany-home-bundle-handoff');
      if (handoffRaw) {
        const handoff = JSON.parse(handoffRaw);
        sessionStorage.removeItem('beany-home-bundle-handoff');
        if (handoff.bags) bags = String(handoff.bags);
        if (handoff.flavors && typeof handoff.flavors === 'object') {
          handoffSelections = handoff.flavors;
        }
      }
    }
  } catch (_err) {
    /* ignore */
  }

  const REF_CENTS_PER_BAG = 12495;
  const CLUB_SALE_BY_TIER = {
    1: 11795,
    2: 19990,
    3: 26985,
    4: 32780,
  };
  const CLUB_SAVINGS_BY_TIER = {
    1: 6,
    2: 20,
    3: 28,
    4: 34,
  };
  // Product one-time — coffee sale; % with gifts is computed via getSavingsLabel
  const ONE_TIME_SALE_BY_TIER = {
    1: 12495,
    2: 21990,
    3: 31485,
    4: 37980,
  };
  const ONE_TIME_COMPARE_BY_TIER = {
    1: 12495,
    2: 24990,
    3: 37485,
    4: 49980,
  };
  // Coffee-only fallbacks (banner uses gift-inclusive getSavingsLabel instead)
  const ONE_TIME_SAVINGS_BY_TIER = {
    1: 0,
    2: 12,
    3: 16,
    4: 24,
  };
  const CLUB_COMPARE_BY_TIER = {
    1: 12495,
    2: 24990,
    3: 37485,
    4: 49980,
  };
  const pricingMode = isOneTime ? 'one_time' : 'club';
  const tierApi = () => window.BeanyBundleTier;
  const getPricing = (quantity) => {
    if (tierApi()) return tierApi().getPricingForBags(quantity, pricingMode);
    const bags = Math.min(MAX_BAGS(), Math.max(1, Number(quantity) || 1));
    const tier = bags >= 4 ? 4 : bags;
    let sale = isOneTime ? ONE_TIME_SALE_BY_TIER[tier] : CLUB_SALE_BY_TIER[tier];
    let compare = isOneTime ? ONE_TIME_COMPARE_BY_TIER[tier] : CLUB_COMPARE_BY_TIER[tier];
    if (bags > 4) {
      sale = Math.round(sale / 4) * bags;
      compare = Math.round(compare / 4) * bags;
    }
    return {
      sale,
      compare,
      savings: isOneTime ? ONE_TIME_SAVINGS_BY_TIER[tier] : CLUB_SAVINGS_BY_TIER[tier],
      saleDecimal: (sale / 100).toFixed(2),
      compareDecimal: (compare / 100).toFixed(2),
    };
  };

  const requiredEls = root.querySelectorAll('[data-step-2-required], [data-step2-required-count]');
  const bagEls = root.querySelectorAll('[data-step2-bags]');
  const priceEl = root.querySelector('[data-step2-price]');
  const compareEl = root.querySelector('[data-step2-compare]');
  const dynamicHeadline = root.querySelector('[data-step2-dynamic-headline]');
  const mainCta = root.querySelector('[data-step2-main-cta]');
  const mainCtaText = root.querySelector('[data-offer-cta-label]');
  const offerCtaNewEls = Array.from(root.querySelectorAll('[data-offer-cta-new]'));
  const offerCtaOldEls = Array.from(root.querySelectorAll('[data-offer-cta-old]'));
  const savingsTextEl = root.querySelector('[data-step2-saving-text]');
  const giftsCountEl = root.querySelector('[data-step2-gifts-count]');
  const selectedEl = root.querySelector('[data-step2-selected]');
  const cards = Array.from(root.querySelectorAll('[data-flavor-card]'));
  const warmedModalAssets = new Set();
  cards.forEach((card) => {
    [card.dataset.modalImage, card.dataset.modalDeco, card.dataset.modalMotif, card.dataset.modalMotif2].forEach((src) => {
      if (!src || warmedModalAssets.has(src)) return;
      warmedModalAssets.add(src);
      const img = new Image();
      img.decoding = 'async';
      img.src = src;
      if (typeof img.decode === 'function') img.decode().catch(() => {});
    });
  });
  const toggles = Array.from(root.querySelectorAll('[data-flavor-toggle]'));
  const ghostChoices = Array.from(root.querySelectorAll('#quantity-breaks-' + (root.dataset.sectionId || '') + ' input[data-bundle-choice], .step-2-ghost-quantity input[data-bundle-choice]'));

  const infoModal = root.querySelector('[data-step2-info-modal]');
  const infoModalClose = root.querySelector('[data-step2-info-modal-close]');
  const infoModalBackdrop = root.querySelector('[data-step2-info-modal-backdrop]');
  const infoModalTitle = root.querySelector('[data-step2-info-modal-title]');
  const infoModalFlavor = root.querySelector('[data-step2-info-modal-flavor]');
  const infoModalDesc = root.querySelector('[data-step2-info-modal-desc]');
  const infoModalImg = root.querySelector('[data-step2-info-modal-img]');
  const infoModalHero = root.querySelector('[data-step2-info-modal-hero]');
  const infoModalDeco = root.querySelector('[data-step2-info-modal-deco]');
  const infoModalMotifs = root.querySelector('[data-step2-info-modal-motifs]');
  const labelSection = root.querySelector('[data-step2-modal-label-section]');
  const labelToggle = root.querySelector('[data-step2-modal-label-toggle]');

  const requiredBags = Math.max(1, Number(bags) || 2);
  const initialPricing = getPricing(requiredBags);
  const price = initialPricing.saleDecimal;
  const compare = initialPricing.compareDecimal;

  requiredEls.forEach((el) => {
    el.textContent = bags;
  });
  bagEls.forEach((el) => {
    el.textContent = bags;
  });
  if (priceEl) priceEl.textContent = `₪${price}`;
  if (compareEl) compareEl.textContent = `₪${compare}`;
  const syncOfferCtaPrices = (pricing) => {
    const saleText =
      pricing?.saleText ||
      (pricing?.saleDecimal != null ? `₪${pricing.saleDecimal}` : null) ||
      (pricing?.sale != null ? `₪${(pricing.sale / 100).toFixed(2)}` : null);
    const compareText =
      pricing?.compareText ||
      (pricing?.compareDecimal != null ? `₪${pricing.compareDecimal}` : null) ||
      (pricing?.compare != null ? `₪${(pricing.compare / 100).toFixed(2)}` : null);
    if (saleText) {
      offerCtaNewEls.forEach((el) => {
        el.textContent = saleText;
      });
    }
    if (compareText) {
      const hasDiscount = !(Number(pricing?.compare) <= Number(pricing?.sale));
      offerCtaOldEls.forEach((el) => {
        el.textContent = compareText;
        el.hidden = !hasDiscount;
      });
    }
  };
  syncOfferCtaPrices(initialPricing);

  const getRequiredHeadlineText = (requiredQuantity) => {
    if (isOneTime) return '';
    if (requiredQuantity === 1) return 'בחרו לפחות שקית 1';
    return `בחרו לפחות ${requiredQuantity} שקיות`;
  };

  // Same stack as the product page: coffee compare + gift value (Welcome / Boost).
  // Match bundle-tier-config clubGiftValueCents / oneTimeGiftValueCents.
  const ONE_TIME_GIFT_CENTS_BY_TIER = { 1: 4780, 2: 6770, 3: 6770, 4: 6770 };
  const CLUB_GIFT_CENTS_BY_TIER = { 1: 5585, 2: 10365, 3: 10365, 4: 10365 };
  const isHomePricing = (pricing) =>
    pricing?.context === 'home' &&
    !(window.BeanyBundleTier?.isBoostOfferContext?.() === true) &&
    !(window.BeanyBundleTier?.isProductPricingContext?.() === true);

  const giftCentsFor = (pricing, quantity) => {
    if (isHomePricing(pricing)) return 0;
    const fromPricing = Number(pricing?.giftValueCents);
    if (Number.isFinite(fromPricing) && fromPricing > 0) return fromPricing;
    const tier = Math.min(4, Math.max(1, Number(quantity) || 1));
    return isOneTime ? ONE_TIME_GIFT_CENTS_BY_TIER[tier] : CLUB_GIFT_CENTS_BY_TIER[tier];
  };

  const getSavingsLabel = (pricing, quantity) => {
    const sale = Number(pricing?.sale) || 0;
    const compare = Number(pricing?.compare) || 0;
    const gifts = giftCentsFor(pricing, quantity);
    const value = compare + gifts;
    const percent = value > 0 ? Math.round(((value - sale) / value) * 100) : 0;
    return percent > 0 ? `${percent}%` : null;
  };

  const maxSavingsPercent = () => {
    let max = 0;
    for (let tier = 1; tier <= 4; tier += 1) {
      const label = getSavingsLabel(getPricing(tier), tier);
      const n = Number(String(label || '').replace('%', ''));
      if (Number.isFinite(n) && n > max) max = n;
    }
    return max;
  };

  const syncWelcomeSavingsCopy = () => {
    if (isOneTime) return;
    const maxPercent = maxSavingsPercent() || 46;
    root.querySelectorAll(
      '.step2v2-intro__lead-sub.beany-welcome-only, [data-step2-welcome-savings-copy]'
    ).forEach((el) => {
      el.textContent = `חיסכון של עד ${maxPercent}% + מתנות חינמיות בהזמנה הראשונה שלכם !`;
      el.hidden = false;
      el.style.display = '';
    });
    root.querySelectorAll('.step2v2-intro__lead-sub.beany-returning-only').forEach((el) => {
      if (window.BEANY_BOOST_OFFER === true || document.documentElement.classList.contains('beany-boost')) {
        el.hidden = true;
        el.style.display = 'none';
      }
    });
  };

  const syncOneTimeSummerBanner = () => {
    if (!isOneTime) return;
    // Max % across tiers — coffee compare + welcome gift value (same stack as club).
    let maxPercent = Math.max(
      ...[1, 2, 3, 4].map((tier) => {
        const label = getSavingsLabel(getPricing(tier), tier);
        const n = Number(String(label || "").replace("%", ""));
        return Number.isFinite(n) ? n : 0;
      })
    );
    if (!Number.isFinite(maxPercent) || maxPercent <= 0) maxPercent = 34;

    const pctEl = root.querySelector('.summer-banner--step2-one-time [data-summer-savings-percent]');
    const giftsEl = root.querySelector('.summer-banner--step2-one-time [data-summer-gifts-label]');
    if (pctEl) pctEl.textContent = `${maxPercent}%`;
    if (giftsEl) giftsEl.textContent = 'מתנות חינמיות';
    root.querySelectorAll('.summer-banner--step2-one-time').forEach((banner) => {
      banner.setAttribute(
        'aria-label',
        `מבצע shoppingil התחיל בביני ! — חיסכון של עד ${maxPercent}% + מתנות חינמיות`
      );
    });

    root.querySelectorAll('.step2v2-header__savings-title.beany-welcome-only').forEach((el) => {
      el.textContent = `חיסכון של עד ${maxPercent}%`;
    });
  };
  const getCtaText = (requiredQuantity, selectedQuantity = 0) => {
    if (selectedQuantity >= requiredQuantity) return 'להמשך תשלום';
    if (requiredQuantity === 1) return 'בחרו לפחות שקית 1';
    const remaining = requiredQuantity - selectedQuantity;
    if (remaining === 1) return 'בחרו את השקית האחרונה שלכם';
    return `בחרו לפחות ${requiredQuantity} שקיות`;
  };
  const requiredCopy = getCtaText(requiredBags, 0);
  const requiredHeadlineCopy = getRequiredHeadlineText(requiredBags);
  const initialSavingsText = getSavingsLabel(getPricing(requiredBags), requiredBags);
  let wasReady = false;
  if (dynamicHeadline && !isOneTime) {
    dynamicHeadline.textContent = requiredHeadlineCopy;
  }
  syncOneTimeSummerBanner();
  syncWelcomeSavingsCopy();
  if (mainCtaText) mainCtaText.textContent = requiredCopy;
  if (mainCta) {
    mainCta.setAttribute('aria-label', requiredCopy);
    mainCta.disabled = true;
    mainCta.hidden = false;
  }
  if (savingsTextEl) {
    if (initialSavingsText) {
      savingsTextEl.textContent = `חוסכים ${initialSavingsText}`;
      savingsTextEl.hidden = false;
    } else {
      savingsTextEl.hidden = true;
    }
  }
  ghostChoices.forEach((input) => {
    input.checked = Number(input.value) === requiredBags;
  });

  const renderAddButton = (button, qty) => {
    if (!button) return;
    const label = button.querySelector('[data-flavor-label]');
    const defaultLabel = button.getAttribute('data-add-default') || 'הוספה +';
    if (qty > 0) {
      button.classList.add('is-qty');
      button.innerHTML = `
        <span class="beany-bundle-flavor__qty" data-flavor-qty>
          <button type="button" class="beany-bundle-flavor__qty-btn" data-qty-plus aria-label="הוסף">+</button>
          <span class="beany-bundle-flavor__qty-value" data-qty-value>${qty}</span>
          <button type="button" class="beany-bundle-flavor__qty-btn" data-qty-minus aria-label="הפחת">-</button>
        </span>
      `;
    } else {
      button.classList.remove('is-qty');
      if (label) {
        label.textContent = defaultLabel;
      } else {
        button.innerHTML = `<span class="beany-bundle-flavor__add-label" data-flavor-label>${defaultLabel}</span>`;
      }
    }
  };

  const animateQtyValue = (button) => {
    const valueEl = button?.querySelector('[data-qty-value]');
    if (!valueEl) return;
    valueEl.classList.remove('is-pop');
    void valueEl.offsetWidth;
    valueEl.classList.add('is-pop');
  };

  const pulseAddSuccess = (button) => {
    if (!button) return;
    button.classList.remove('is-success');
    void button.offsetWidth;
    button.classList.add('is-success');
    window.setTimeout(() => {
      button.classList.remove('is-success');
    }, 280);
  };

  const getGiftsOpenedAndTotal = () => {
    const giftSlots = Array.from(root.querySelectorAll('[data-gift-slot]'));
    if (giftSlots.length) {
      const opened = giftSlots.filter((slot) => slot.classList.contains('is-open')).length;
      return { opened, total: giftSlots.length };
    }
    if (isOneTime) {
      const opened = requiredBags >= 2 ? 3 : 2;
      return { opened, total: 3 };
    }
    const opened = requiredBags >= 3 ? 5 : requiredBags >= 2 ? 4 : 2;
    return { opened, total: 5 };
  };

  const tierItems = Array.from(root.querySelectorAll('[data-bundle-tier-step]'));
  const tierFillEl = root.querySelector('[data-bundle-tier-fill]');

  const getTierFillPercent = (activeTier) => {
    if (activeTier <= 0) return 0;
    if (activeTier >= 4) return 100;
    if (activeTier === 1) return 0;
    if (activeTier === 2) return 33.333;
    if (activeTier === 3) return 66.666;
    return 0;
  };

  const updateTierBar = (totalQty) => {
    if (!tierItems.length) return;
    const qty = Math.max(0, Number(totalQty) || 0);
    const activeTier = qty > 0 ? (qty >= 4 ? 4 : qty) : 0;
    const api = tierApi();
    tierItems.forEach((item) => {
      const stepTier = Number(item.dataset.bundleTierStep);
      const isActive = activeTier > 0 && stepTier === activeTier;
      const isReached = activeTier > 0 && stepTier <= activeTier;
      item.classList.toggle('is-active', isActive);
      item.classList.toggle('is-reached', isReached);
      item.setAttribute('aria-current', isActive ? 'step' : 'false');
      if (api?.getPricingForBags) {
        const amountEl = item.querySelector('[data-bundle-tier-amount]');
        if (amountEl) {
          const tierPricing = api.getPricingForBags(stepTier, pricingMode);
          amountEl.textContent = tierPricing.perBagText || api.money(tierPricing.perBagCents);
        }
      }
    });
    if (tierFillEl) {
      tierFillEl.style.width = `${getTierFillPercent(activeTier)}%`;
    }
  };

  const updateSummaryMeta = () => {
    const totalQty = cards.reduce((sum, card) => sum + Number(card.dataset.qty || 0), 0);
    const effectiveQuantity = Math.max(requiredBags, totalQty);
    const pricing = getPricing(effectiveQuantity);
    const savingsText = getSavingsLabel(pricing, effectiveQuantity);
    if (savingsTextEl) {
      if (savingsText) {
        savingsTextEl.textContent = `חוסכים ${savingsText}`;
        savingsTextEl.hidden = false;
      } else {
        savingsTextEl.hidden = true;
      }
    }
    // Keep gifts pill visible on Welcome / Boost (returning CSS may hide it).
    root.querySelectorAll('[data-step2-gifts-text], .cta-gifts').forEach((el) => {
      if (isHomePricing(pricing)) return;
      el.hidden = false;
      el.style.display = '';
    });
    syncWelcomeSavingsCopy();
    if (priceEl) priceEl.textContent = `₪${pricing.saleDecimal}`;
    if (compareEl) compareEl.textContent = `₪${pricing.compareDecimal}`;
    syncOfferCtaPrices(pricing);
    const { opened, total } = getGiftsOpenedAndTotal();
    if (giftsCountEl) {
      const totalEl = giftsCountEl.querySelector("[data-gifts-total]");
      const openedEl = giftsCountEl.querySelector("[data-gifts-opened]");
      if (totalEl && openedEl) {
        totalEl.textContent = String(total);
        openedEl.textContent = String(opened);
      } else {
        giftsCountEl.textContent = `${total}/${opened}`;
      }
    }
    updateTierBar(totalQty);
  };

  const updateSelectedCount = () => {
    const selectedCount = cards.filter((card) => Number(card.dataset.qty || 0) > 0).length;
    const totalQty = cards.reduce((sum, card) => sum + Number(card.dataset.qty || 0), 0);
    if (selectedEl) selectedEl.textContent = String(selectedCount);
    if (mainCta) {
      const isReady = totalQty >= requiredBags;
      mainCta.disabled = !isReady;
      mainCta.classList.toggle('is-disabled', !isReady);
      mainCta.setAttribute('aria-disabled', isReady ? 'false' : 'true');
      mainCta.hidden = false;
      const ctaText = getCtaText(requiredBags, totalQty);
      if (mainCtaText) mainCtaText.textContent = ctaText;
      mainCta.setAttribute('aria-label', ctaText);
      if (isReady && !wasReady) {
        mainCta.classList.remove('is-activate');
        void mainCta.offsetWidth;
        mainCta.classList.add('is-activate');
      }
      wasReady = isReady;
    }
    document.dispatchEvent(
      new CustomEvent('bundle:state-change', {
        detail: {
          minimumRequiredBags: requiredBags,
          actualSelectedBags: Math.max(requiredBags, totalQty),
          sectionId: root.dataset.sectionId,
        },
      })
    );
    updateSummaryMeta();
  };

  toggles.forEach((button) => {
    const card = button.closest('[data-flavor-card]');
    if (card) card.dataset.qty = '0';
    button.addEventListener('click', () => {
      const card = button.closest('[data-flavor-card]');
      if (!card) return;
      if (button.classList.contains('is-qty')) return;
      const totalQty = cards.reduce((sum, c) => sum + Number(c.dataset.qty || 0), 0);
      if (totalQty >= MAX_BAGS()) return;
      card.dataset.qty = '1';
      card.classList.add('is-selected');
      renderAddButton(button, 1);
      pulseAddSuccess(button);
      animateQtyValue(button);
      updateSelectedCount();
    });
  });

  root.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-flavor-toggle]');
    if (addButton && !addButton.classList.contains('is-qty')) {
      event.preventDefault();
      const card = addButton.closest('[data-flavor-card]');
      if (!card) return;
      const totalQty = cards.reduce((sum, c) => sum + Number(c.dataset.qty || 0), 0);
      if (totalQty >= MAX_BAGS()) return;
      card.dataset.qty = '1';
      card.classList.add('is-selected');
      renderAddButton(addButton, 1);
      pulseAddSuccess(addButton);
      animateQtyValue(addButton);
      updateSelectedCount();
      return;
    }

    const plus = event.target.closest('[data-qty-plus]');
    const minus = event.target.closest('[data-qty-minus]');
    if (!plus && !minus) return;
    event.preventDefault();
    const card = event.target.closest('[data-flavor-card]');
    const button = card?.querySelector('[data-flavor-toggle]');
    if (!button || !card) return;
    const current = Number(card.dataset.qty || 0);
    const totalQty = cards.reduce((sum, c) => sum + Number(c.dataset.qty || 0), 0);
    let next = current;
    if (plus) {
      if (totalQty >= MAX_BAGS()) return;
      next = current + 1;
    } else {
      next = Math.max(0, current - 1);
    }
    card.dataset.qty = String(next);
    card.classList.toggle('is-selected', next > 0);
    renderAddButton(button, next);
    animateQtyValue(button);
    updateSelectedCount();
  });

  const updateModalContent = (card) => {
    if (!card) return;
    const title = card.dataset.modalTitle || '';
    const flavor = card.dataset.modalFlavor || '';
    const desc = card.dataset.modalDesc || '';
    const image = card.dataset.modalImage || '';
    const deco = card.dataset.modalDeco || '';
    const motif = card.dataset.modalMotif || '';
    const motif2 = card.dataset.modalMotif2 || motif;
    const tone = card.dataset.modalTone || 'original';
    if (infoModalTitle) infoModalTitle.textContent = title;
    if (infoModalFlavor) infoModalFlavor.textContent = flavor;
    if (infoModalDesc) {
      infoModalDesc.textContent = desc;
      infoModalDesc.hidden = !desc;
    }
    if (infoModalImg) {
      if (image) {
        infoModalImg.src = image;
        infoModalImg.alt = flavor || title || '';
        infoModalImg.hidden = false;
      } else {
        infoModalImg.removeAttribute('src');
        infoModalImg.hidden = true;
      }
    }
    if (infoModalHero) infoModalHero.setAttribute('data-tone', tone);
    if (infoModalDeco) {
      if (deco) {
        infoModalDeco.style.backgroundImage = `url("${deco}")`;
        infoModalDeco.hidden = false;
      } else {
        infoModalDeco.style.backgroundImage = '';
        infoModalDeco.hidden = true;
      }
    }
    if (infoModalMotifs) {
      const imgs = infoModalMotifs.querySelectorAll('[data-motif-img]');
      imgs.forEach((img, index) => {
        const src = index % 2 === 0 ? motif : motif2;
        if (src) {
          img.src = src;
          if (img.getAttribute('src') !== src) img.src = src;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }
      });
      infoModalMotifs.hidden = !motif;
    }
    if (infoModal) {
      infoModal.querySelectorAll('[data-nutrition-tone]').forEach((panel) => {
        const match = panel.getAttribute('data-nutrition-tone') === tone;
        panel.hidden = !match;
        panel.setAttribute('aria-hidden', match ? 'false' : 'true');
      });
    }
  };

  const resetLabelAccordion = () => {
    if (labelSection) labelSection.classList.remove('is-open');
    if (labelToggle) labelToggle.setAttribute('aria-expanded', 'false');
  };

  const closeInfoModal = () => {
    if (!infoModal || !infoModal.classList.contains('is-open')) return;
    infoModal.classList.remove('is-open');
    infoModal.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      document.body.classList.remove('step-2-info-modal-open');
      resetLabelAccordion();
    }, 320);
  };

  const openInfoModal = (flavor) => {
    if (!infoModal) return;
    const card = root.querySelector(`[data-flavor-card][data-flavor="${flavor}"]`);
    if (!card) return;
    updateModalContent(card);
    resetLabelAccordion();
    document.body.classList.add('step-2-info-modal-open');
    infoModal.setAttribute('aria-hidden', 'false');
    // Ensure the closed styles paint before opening, so the enter transition runs.
    window.requestAnimationFrame(() => {
      infoModal.classList.add('is-open');
      window.requestAnimationFrame(() => {
        if (infoModalClose && typeof infoModalClose.focus === 'function') infoModalClose.focus();
      });
    });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (infoModal?.classList.contains('is-open')) {
      event.preventDefault();
      closeInfoModal();
    }
  });

  root.querySelectorAll('.beany-bundle-flavor__info-btn[data-flavor], .step-2-flavor__info-btn[data-flavor]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const flavor = btn.getAttribute('data-flavor');
      if (!flavor) return;
      openInfoModal(flavor);
    });
  });

  if (infoModalClose) {
    infoModalClose.addEventListener('click', (event) => {
      event.preventDefault();
      closeInfoModal();
    });
  }

  if (infoModalBackdrop) {
    infoModalBackdrop.addEventListener('click', (event) => {
      event.preventDefault();
      closeInfoModal();
    });
  }

  if (labelToggle && labelSection) {
    labelToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      labelSection.classList.toggle('is-open');
      labelToggle.setAttribute('aria-expanded', labelSection.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  if (handoffSelections) {
    let remaining = MAX_BAGS();
    Object.entries(handoffSelections).forEach(([flavorKey, qty]) => {
      const mapped = flavorKeyMap[flavorKey] || flavorKey;
      const card = root.querySelector(`[data-flavor-card][data-flavor="${mapped}"]`);
      let qtyNum = Math.max(0, Number(qty) || 0);
      if (!card || qtyNum < 1 || remaining < 1) return;
      qtyNum = Math.min(qtyNum, remaining);
      remaining -= qtyNum;
      const button = card.querySelector('[data-flavor-toggle]');
      if (!button) return;
      card.dataset.qty = String(qtyNum);
      card.classList.add('is-selected');
      renderAddButton(button, qtyNum);
    });
  }

  updateSelectedCount();
  updateSummaryMeta();

  const backButton = root.querySelector('[data-step-2-back]');
  if (backButton) {
    backButton.addEventListener('click', (event) => {
      event.preventDefault();
      navigateBackToProduct(fallbackProductUrl);
    });
  }

  const getCartLineItems = () => {
    const items = cards
      .map((card) => ({
        id: Number(card.dataset.variantId),
        quantity: Number(card.dataset.qty || 0),
      }))
      .filter((item) => item.id && item.quantity > 0);
    const planId = window.BeanyBundleTier?.sellingPlanIdForBags?.(
      items.reduce((sum, item) => sum + item.quantity, 0),
      pricingMode
    );
    if (!planId) return items;
    return items.map((item) => ({ ...item, selling_plan: planId }));
  };

  if (mainCta) {
    mainCta.addEventListener('click', async () => {
      if (mainCta.disabled) return;

      const coffeeItems = getCartLineItems();
      if (!coffeeItems.length) return;
      const bags = coffeeItems.reduce((sum, item) => sum + item.quantity, 0);
      const giftIds = window.BeanyCheckout?.giftVariantIds?.(pricingMode, bags) || [];
      const items = coffeeItems.concat(giftIds.map((id) => ({ id: Number(id), quantity: 1 })));
      if (giftIds.length) window.__beanyGiftCode = "TRYBEANYGIFT";

      mainCta.classList.add('loading');
      mainCta.setAttribute('aria-busy', 'true');
      document.body.classList.add('beany-screen-wait');
      const spinner = mainCta.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      try {
        const cartHasItems = !!document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (cartHasItems) {
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
          });
        }

        const addUrl = window.routes?.cart_add_url
          ? `${String(window.routes.cart_add_url).replace(/\.js$/, '')}.js`
          : '/cart/add.js';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        const parsed = await response.json().catch(() => ({}));
        // /cart/add (without .js) returns {errors} and no status. Treating that
        // as success sent an empty cart to /checkout, and Shopify bounced home.
        if (!response.ok || parsed.status || parsed.errors) {
          console.error(parsed.description || parsed.message || parsed.errors || 'cart add failed');
          return;
        }

        const welcome = window.BeanyCheckout?.funnel?.() === 'welcome';
        if (!welcome || giftIds.length) {
          window.__beanyBuiltCart = { mode: pricingMode, bags, at: Date.now() };
        }

        if (window.BeanyCheckout) {
          await window.BeanyCheckout.checkout(pricingMode);
        } else {
          window.location.href = '/checkout';
        }
      } catch (error) {
        console.error(error);
      } finally {
        const leftForCheckout = /\/checkout|\/invoices|\/checkouts/.test(document.location.pathname);
        if (!leftForCheckout) {
          document.body.classList.remove('beany-screen-wait');
          mainCta.classList.remove('loading');
          mainCta.removeAttribute('aria-busy');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    });
  }
});
